import type { HistoryTab } from '../../pages/TradingHistory';
import type { MarketScope } from '../../types/marketScope';

interface HistoryFiltersProps {
  tab: HistoryTab;
  market: MarketScope;
  symbol: string;
  action: string;
  tradeType: string;
  startDate: string;
  endDate: string;
  onSymbolChange: (value: string) => void;
  onActionChange: (value: string) => void;
  onTradeTypeChange: (value: string) => void;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onSearch: () => void;
}

export default function HistoryFilters(props: HistoryFiltersProps) {
  const isKrRealized = props.market === 'KR' && props.tab === 'realized';
  return (
    <div className="history-filters">
      {props.tab === 'execution' ? <ExecutionFilters {...props} /> : <TradeFilters {...props} />}
      <input type="date" value={props.startDate} onChange={(event) => props.onStartDateChange(event.target.value)} />
      <input type="date" value={props.endDate} onChange={(event) => props.onEndDateChange(event.target.value)} />
      <button onClick={props.onSearch} disabled={isKrRealized}>조회</button>
    </div>
  );
}

function ExecutionFilters(props: HistoryFiltersProps) {
  return (
    <>
      <input value={props.symbol} onChange={(event) => props.onSymbolChange(event.target.value.toUpperCase())} placeholder="종목" />
      <select value={props.action} onChange={(event) => props.onActionChange(event.target.value)}>
        <option value="ALL">전체 액션</option>
        <option value="BUY">BUY</option>
        <option value="SELL">SELL</option>
        <option value="HOLD">HOLD</option>
      </select>
    </>
  );
}

function TradeFilters(props: HistoryFiltersProps) {
  return (
    <select value={props.tradeType} onChange={(event) => props.onTradeTypeChange(event.target.value)}>
      <option value="ALL">전체 유형</option>
      <option value="TAKE_PROFIT">수익 실현</option>
      <option value="STOP_LOSS">손절</option>
      <option value="STRATEGY_SELL">전략 매도</option>
    </select>
  );
}
